import { render, staticRenderFns } from "./messageInbox.vue?vue&type=template&id=51045767"
import script from "./messageInbox.vue?vue&type=script&lang=js"
export * from "./messageInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports